var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItalianFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_884)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_44_884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1664 2.81952H-14.4375V76.8193H94.4682V2.81952H58.1664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.4375 2.82056H21.8636V76.8214H-14.4375V2.82056Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.167 2.82056H94.4681V76.8214H58.167V2.82056Z",
    fill: "#D80027"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -13.9375,
    y: 3.32056,
    width: 107.906,
    height: 73,
    stroke: "#C4C4C4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "white",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_884"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_44_884"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14.4375,
    y: 2.82056,
    width: 108.906,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalianFlag);
export default __webpack_public_path__ + "static/media/italian-flag.b48af20f62b7f1688efb5ccf8a9e6572.svg";
export { ForwardRef as ReactComponent };